import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const tariffBuyUTMSourceStringLimit: number = getFeature('tariff-buy-utm-source-string-limit') || 200;
